import { Card } from "@/components/ui/card";
import { Callout } from "./callout";

export const IndustriesCard = () => {
  return (
    <Card className="relative overflow-clip px-8">
      <div className="flex flex-wrap justify-between md:flex-nowrap">
        <div className="relative max-w-lg">
          <Callout>Use Cases and Industries</Callout>
          <p className="my-4 text-2xl">Who Can Benefit from Flash Biometrics?</p>
          <div className="space-y-6 font-serif max-sm:text-lg/8">
            <ul className="list-disc px-6">
              <li>Sports and Event Management</li>
              <li>Co-Working Spaces</li>
              <li>Fitness and Health Clubs</li>
              <li>E-Commerce Platforms</li>
              <li>Education and Testing Centers</li>
              <li>Financial Services</li>
              <li>Hospitality and Travel</li>
              <li>Private Communities and Clubs</li>
            </ul>
          </div>
        </div>
      </div>
    </Card>
  );
};
